import { userHasSomeRights } from "../../../functions/userRights";
import i18n from "../../../functions/i18next";

export default {
  data() {
    return {
      menuItems: [
        {
          title: i18n.tc("spaces.space", 2),
          icon: "space",
          link: "spaces",
          linkList: ["/home/expanded/", "/myspace/expanded/"],
          rights: [],
        },
        {
          title: i18n.tc("collection.collection", 2),
          icon: "collection",
          link: "collections",
          linkList: ["/collection/expanded/", "/collect-for-download"],
          rights: ["collect"],
          alternatives: [
            {
              condition: !this.$store.state.user,
              title: i18n.t("collection.collect_for_download"),
              icon: "collection",
              link: "collect-for-download",
              linkList: [],
            },
          ],
        },
        {
          title: i18n.t("common.upload"),
          icon: "upload--icon",
          link: "upload",
          linkList: [],
          rights: ["create_files", "create_folders"],
        },
        {
          title: i18n.t("transfer.transfer"),
          icon: "transfer",
          link: "mobile-transfer",
          linkList: [],
          rights: ["quick-transfer", "transfer_files", "transfer_folders"],
        },
        {
          title: i18n.t("login.login"),
          icon: "account",
          link: "login",
          linkList: [],
          alternatives: [
            {
              condition: this.$store.state.user,
              title: i18n.t("settings_menu.account"),
              icon: "account",
              link: "account",
              linkList: [],
            },
          ],
        },
      ],
    };
  },
  methods: {
    createLink(link) {
      return `/${this.$store.state.company}/${link}`;
    },
    fullReset() {
      this.resetUploadMode();
      this.resetTransferMode();
    },
    resetUploadMode() {
      this.$store.state.isUploadingMobile = false;

      this.$store.state.uploadFiles = [];
      this.$store.state.uploadFolderInfo = {};
    },
    resetTransferMode() {
      this.$store.state.isTransfering = false;

      //wipe data if not transfering anymore
      this.$store.state.transferItems = {
        selectedFiles: [],
        selectedFolders: [],
        collection: {},
      };
    },
    hasRights(rights) {
      if (rights) {
        return userHasSomeRights(rights, this);
      } else {
        return true;
      }
    },
  },
  computed: {
    filterdMenuItems() {
      return this.menuItems.map((item) => {
        if (item.alternatives) {
          let usedItem = item;
          item.alternatives.forEach((alt) => {
            if (alt.condition) {
              //condition is met render this alternative instead of o.g.
              usedItem = alt;
            }
          });

          return usedItem;
        }

        return item;
      });
    },
  },
};
